/* @flow */
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import RequireForAccess from 'react-access';
import LazyLoad, { forceCheck } from 'react-lazyload';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';

import WidgetStore from 'stores/WidgetStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import { Draggable } from 'components/DragDrop';

import availableWidgets from './availableWidgetList';
import type { AvailableWidget } from './availableWidgetList';
import styles from './AvailableContainer.module.scss';

type InjectedProps = {
  widgetStore: WidgetStore,
} & TranslatorProps;

@translate()
@inject('widgetStore')
@observer
export default class AvailableContainer extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  @computed get availableFavouriteWidgets(): AvailableWidget[] {
    return availableWidgets.filter(widget =>
      this.props.widgetStore.favouriteWidgets.includes(widget.data)
    );
  }

  @computed get availableNonFavouriteWidgets(): AvailableWidget[] {
    return availableWidgets.filter(
      widget => !this.props.widgetStore.favouriteWidgets.includes(widget.data)
    );
  }

  @computed get sortedAvailableWidgets(): AvailableWidget[] {
    return [...this.availableFavouriteWidgets, ...this.availableNonFavouriteWidgets];
  }

  componentDidMount() {
    setTimeout(forceCheck, 300);
  }
  render() {
    const { t } = this.props;

    return (
      <div className={styles['d-widget-container']}>
        <Card className={styles['d-widget']}>
          <CardHeader
            className={styles['d-widget-header']}
            title={
              <Typography variant="headline">
                {t('general:dashboards.available_widgets')}
              </Typography>
            }
          />
          <CardContent className={styles['d-widget-content']} onScroll={forceCheck}>
            {this.sortedAvailableWidgets.map(widget => {
              return (
                <RequireForAccess permissions={widget.permissions} key={widget.data}>
                  <LazyLoad height={200} once={true} overflow={true}>
                    <Draggable data={{ type: widget.type, data: widget.data }}>
                      <widget.component />
                    </Draggable>
                  </LazyLoad>
                </RequireForAccess>
              );
            })}
          </CardContent>
        </Card>
      </div>
    );
  }
}
